/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {useState, Fragment} from 'react';
import {FormControl} from 'react-bootstrap';
import {ConfirmationDialog} from "../../Common/ConfirmationDialog";

import {OrganizationFieldEditor} from "../../../Models/Core/ServiceDrivenEditors";
import {RootProgramFieldEditor} from "../../../Models/Core/FieldEditors";
import {ConservationActionTypeFieldEditor} from "../../../Models/Core/ServiceDrivenEditors";

export const CopySurveyModal = props => {
    const {surveyTypes, targetConservationActionTypeId, targetSurveyTypeId, targetOrganizationId, targetProgramId, onHide} = props;
    const [surveyTypeId, setSurveyTypeId] = useState(targetSurveyTypeId);
    const [conservationActionTypeId, setConservationActionTypeId] = useState(targetConservationActionTypeId);
    const [organizationId, setOrganizationId] = useState(targetOrganizationId);
    const [programId, setProgramId] = useState(targetProgramId);

    return (
        <ConfirmationDialog
            Display={props.show}
            Title={`Copy Existing Survey`}
            OnConfirm={() => props.onConfirm(surveyTypeId, conservationActionTypeId, organizationId, programId) }
            OnClose={onHide}
            ConfirmationButtonMessage={"Copy Survey"}
            CancelButtonMessage={"Cancel"}
            DisableConfirmationButton={!(surveyTypeId && conservationActionTypeId)}
        >
            <div key={1}>
                <p>Select a Survey Type and Conservation Action Type for the new survey:</p>
                <label>Survey Type</label>
                <FormControl
                    as="select"
                    value={surveyTypeId}
                    onChange={(e) => setSurveyTypeId(e.target.value)}
                >
                    <option value={''}>Select a Survey</option>
                    {
                        surveyTypes.map(x => (
                            <option key={x.surveyTypeId} value={x.surveyTypeId}>
                                {x.name}
                            </option>
                        ))}
                </FormControl>
                <br/>
                <label>Conservation Action Type</label>
                <ConservationActionTypeFieldEditor
                    Value={conservationActionTypeId}
                    OnUpdate={(conservationActionTypeId) => setConservationActionTypeId(conservationActionTypeId)}
                />
                <br/>
                <label>Organization</label>
                <OrganizationFieldEditor
                    Value={organizationId}
                    OnUpdate={(organizationId) => setOrganizationId(organizationId)}
                />
                {
                    !!organizationId &&
                    <Fragment>
                        <br/>
                        <label>Program</label>
                        <RootProgramFieldEditor
                            CustomData={organizationId}
                            Value={programId}
                            OnUpdate={(programId) => setProgramId(programId)}
                        />
                    </Fragment>
                }
            </div>
        </ConfirmationDialog>
    );
}


